module.exports = __webpack_public_path__ + "img/logo.4d42323a.png";